// Pure beslisregel voor de scorecard-gate (gebruikt door app/api/deals + test).
// Een interviewproces mag pas een ronde vooruit als de VORIGE ronde een scorecard
// (interview_feedback) heeft. Deze helper bepaalt, gegeven een status-overgang,
// welke ronde die scorecard moet hebben. Retour 0 = geen gate (geen raise, of niets
// om te checken). De grandfather-check (heeft die ronde ook echt een datum?) en de
// DB-lookup blijven in de route - dit is alleen de zuivere rekenregel.

export const IV_RANK = { IV1: 1, IV2: 2, IV3: 3, IV4: 4, IV5: 5, IV6: 6, 'Aanbieding arbeidscontract': 7 };

// Er moet IETS ingevuld zijn, meer niet (eigenaarsbesluit 15 september 2026). Beide
// velden verplicht stellen hield mensen tegen die de ene kant wel te melden hadden
// en de andere nog niet; wie het formulier heeft aangeraakt mag door. Een minimum
// aantal woorden geldt evenmin (eigenaarsbesluit 14 september 2026): korte, rake
// feedback is genoeg. Retour null als de invoer geldig is, anders een Nederlandse
// foutregel.
export function scorecardQualityError(candidateFeedback, clientFeedback) {
  const cf = (candidateFeedback || '').trim();
  const clf = (clientFeedback || '').trim();
  if (!cf && !clf) return 'Vul iets in bij de kandidaat of bij de klant.';
  return null;
}

// ALLE rondes waarvan de scorecard aanwezig moet zijn om deze status-raise toe te
// staan. Bij een sprong (bv. IV1 -> IV4, of IV2 -> Aanbieding) zijn dat álle
// tussenliggende rondes, niet alleen de laatste: elke gepasseerde ronde had zijn
// feedback moeten krijgen. Ondergrens is de vorige rank (de rondes ONDER de oude
// status zijn al eerder gevalideerd); bovengrens is IV(n-1) voor een IVn-pick of de
// hoogste geplande ronde (hiIv) voor de offer. Retour is oplopend gesorteerd.
// De grandfather-regel (een ronde zónder gezette ivDate telt niet mee - een proces
// dat die ronde nooit plande wordt niet bevroren) blijft BEWUST in de route: dit is
// de zuivere rekenregel, de route filtert op ivDate en doet de DB-lookup.
export function scorecardNeedRounds(prevStatus, newStatus, hiIv) {
  const prevRank = IV_RANK[prevStatus] || 0;
  const newRank = IV_RANK[newStatus] || 0;
  if (!(newRank > prevRank)) return []; // geen raise -> nooit gaten
  const m = /^IV([1-6])$/.exec(String(newStatus || ''));
  let top = 0;
  if (m) top = Number(m[1]) - 1;                                  // IVn <- t/m IV(n-1)
  else if (newStatus === 'Aanbieding arbeidscontract') top = Number(hiIv) || 0; // offer <- t/m hoogste geplande ronde
  else return [];
  const lo = Math.max(prevRank, 1);
  const out = [];
  for (let r = lo; r <= top; r++) out.push(r);
  return out;
}

// Enkele-ronde-variant (backward compat + bestaande test): de HOOGSTE ronde die de
// raise vereist. Afgeleid van scorecardNeedRounds zodat de twee nooit uiteenlopen.
export function scorecardNeedRound(prevStatus, newStatus, hiIv) {
  const rounds = scorecardNeedRounds(prevStatus, newStatus, hiIv);
  return rounds.length ? rounds[rounds.length - 1] : 0;
}
